/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Planning status:   * `WAITING` - the calculation is waiting to start.   * `IN_PROGRESS` - the calculation is in progress.   * `FINISHED_IN_TIME` - the calculation was completed before the specified planning time.   * `FINISHED_OUT_OF_TIME` - the calculation was completed because the specified planning time has expired.   * `CANCELED` - the calculation was canceled.   * `FAILED` - the calculation failed with an error. 
 */
export enum PlanStatusLastmile {
    WAITING = 'WAITING',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED_IN_TIME = 'FINISHED_IN_TIME',
    FINISHED_OUT_OF_TIME = 'FINISHED_OUT_OF_TIME',
    CANCELED = 'CANCELED',
    FAILED = 'FAILED'
};

